/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React from 'react';
import { RadioButton as VRadioButton } from '@veneer/core';
import './style.scss';
import { withAnalytics } from '@veneer/analytics';
import { RadioButtonProps } from './types';
import { generateID } from '../../base/helper';

/**
 * UI Toolkit: RadioButton
 * @public
 */
const TRadioButton: React.FC<RadioButtonProps> = ({
  checked,
  id = generateID('clientos-ui-toolkit-radio-button'),
  label,
  onClick,
  value,
  disabled,
  onChange,
  invalid,
  name,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy
}) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault(); // Prevent default scrolling behavior for Spacebar
      if (onChange && !disabled) {
        const syntheticEvent = {
          target: { value }
        } as React.ChangeEvent<HTMLInputElement>;
        onChange(syntheticEvent);
      }
    }
  };
  return (
    <div
      className={`clientos-ui-toolkit-radio-button ${!label ? ' no-label' : ''} ${invalid ? 'invalid' : ''} ${disabled ? 'disabled' : ''} ${checked ? 'checked' : ''}`}
      id={id}
      onKeyDown={handleKeyDown}
    >
      <VRadioButton
        disabled={disabled}
        checked={checked}
        id={`${id}__radio-button`}
        label={label}
        onClick={onClick}
        value={value}
        onChange={onChange}
        name={name}
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
      />
    </div>
  );
};
export const RadioButtonAnalytics = withAnalytics(TRadioButton);
export default TRadioButton;
